const INITIAL_STATE = {
  data: {},
  pauseList: {},
  pauseService: {},
  updatepauseService:{},
  deletePauseService: {},
  editService: {},
  fieldOffice: {},
  pauseReason: {},
  serviceHistory: {},
  errors: {},
}

const service = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'VIEW_SERVICE':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'VIEW_SERVICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_PAUSE_SERVICE':
    return { ...state, ...INITIAL_STATE, pauseList: action.data }
  case 'GET_PAUSE_SERVICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'PAUSE_SERVICE':
    return { ...state, ...INITIAL_STATE, pauseService: action.data }
  case 'PAUSE_SERVICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_PAUSE_SERVICE':
    return { ...state, ...INITIAL_STATE, updatepauseService: action.data }
  case 'UPDATE_PAUSE_SERVICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_PAUSE_SERVICE':
    return { ...state, ...INITIAL_STATE, deletePauseService: action.data }
  case 'DELETE_PAUSE_SERVICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'EDIT_SERVICE':
    return { ...state, ...INITIAL_STATE, editService: action.data }
  case 'EDIT_SERVICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_PAUSE_REASON':
    return { ...state, ...INITIAL_STATE, pauseReason: action.data }
  case 'GET_PAUSE_REASON_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'FIELD_OFFICE':
    return { ...state, ...INITIAL_STATE, fieldOffice: action.data }
  case 'FIELD_OFFICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_SERVICE_HISTORY':
    return { ...state, ...INITIAL_STATE, serviceHistory: action.data }
  case 'GET_SERVICE_HISTORY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'CLEAR_EDIT_SERVICE':
    return { ...INITIAL_STATE }
  default:
    return { ...state }
  }
};

export default service;
